import React from "react";
import * as jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Download from "@material-ui/icons/SaveAlt";
import { primaryShade1 } from "../styles/color";
if (window.cordova) {
  var Permission = window.plugins.Permission;
  var permission = "android.permission.READ_EXTERNAL_STORAGE";

  Permission.has(
    permission,
    function(results) {
      if (!results[permission]) {
        Permission.request(
          permission,
          function(results) {
            if (results[permission]) {
              // permission is granted
            }
          },
          alert
        );
      }
    },
    alert
  );
}

const DownloadPDFButton = ({ invoiceId, invoiceNumber }) => (
  <div className="tc mb4 mt2">
    <div id="myMm" style={{ height: "1mm" }} />

    <div
      onClick={() => {
        var platform = null;
        var random = Math.floor(Math.random() * (+1000 - +1)) + +1;
        const input = document.getElementById(invoiceId);
        const pdfInput = document.getElementById(invoiceId).innerHTML;
        const fileName = `${invoiceNumber + "_" + random}.pdf`;
        var doc = new jsPDF("p", "pt", "a4");
        html2canvas(input, {
          scale: "2"
        }).then(canvas => {
          var imgData = canvas.toDataURL("image/png");
          var pageHeight = 295;
          var imgWidth = (canvas.width * 50) / 210 - 30;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;
          var position = 5;
          doc.addImage(imgData, "PNG", 0, 0, 595, 842);
          heightLeft -= pageHeight;
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, "PNG", 0, 0, 595, 842);
            heightLeft -= pageHeight;
          }

          doc.save(fileName);
        });
        if (window.cordova) {
          platform = window.device.platform;
          let options = {
            documentSize: "A4",
            fileName: `${fileName}`,
            type: "share"
          };
          window.cordova.plugins.pdf
            .fromData(pdfInput, options)
            .catch(err => console.log(err));

          if (platform === "Android") {
            window.plugins.socialsharing.share(
              "Here is your PDF file",
              "Your PDF",
              `file:///storage/emulated/0/Download/${fileName}`
            );
          }
        }
      }}
    >
      <Download style={{ color: "white" }} width={"40px"} height={"40px"} />
    </div>
  </div>
);
export default DownloadPDFButton;
